import { type Consumer, createConsumer } from "@rails/actioncable";

let consumer: Consumer | null = null;

export function getCableConsumer() {
  if (!consumer) {
    consumer = createConsumer("/cable");
  }

  return consumer;
}
